import { render, staticRenderFns } from "./addGetwayConfig.vue?vue&type=template&id=005500f9&"
import script from "./addGetwayConfig.vue?vue&type=script&lang=js&"
export * from "./addGetwayConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005500f9')) {
      api.createRecord('005500f9', component.options)
    } else {
      api.reload('005500f9', component.options)
    }
    module.hot.accept("./addGetwayConfig.vue?vue&type=template&id=005500f9&", function () {
      api.rerender('005500f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pakgConfig/components/addGetwayConfig.vue"
export default component.exports